<div>
  <!--  content-->
  @if (data.type === 'underage') {
    <ng-container [ngTemplateOutlet]="underage"></ng-container>
  } @else if (data.type === 'closeBrowser'){
    <ng-container [ngTemplateOutlet]="closeBrowser"></ng-container>
  }
</div>


<ng-template #underage>
  <div class="w-100 d-flex justify-content-center align-items-center flex-column text-center max-height-90">
    <div class="pt-3 pe-3 d-flex w-100 justify-content-end">
      <app-button
        (clicked)="close()"
        [ariaLabel]="'accessibility.close' | translate"
        [class]="'button-color-gray'"
        [color]="'gray'"
        [svgIcon]="'close_x'"
        [type]="'circle'">
      </app-button>
    </div>
    <div class="info-header-title">{{ 'login.isUnderageTitle' | translate }}</div>
    <div class="p-3 overflow-auto">
      @if (today < restrictionDate) {
        {{ 'login.isUnderagePreDescription.0' | translate }}&nbsp;{{ restrictionDate | date : 'dd.MM.yyyy' }}&nbsp;{{ 'login.isUnderagePreDescription.1' | translate }}
      } @else {
        {{ 'login.isUnderageDescription.0' | translate }}&nbsp;{{ restrictionDate | date : 'dd.MM.yyyy' }}&nbsp;{{ 'login.isUnderageDescription.1' | translate }}
      }
      &nbsp;<a class="link-color" href="{{'login.isUnderageLink.1' | translate}}"
    target="_blank">{{ 'login.isUnderageLink.0' | translate }}</a>
  </div>
  <div class="pb-3 max-width-8-rem ">
    <app-button
      (clicked)="close()"
      [ariaLabel]="'accessibility.close' | translate"
      [class]="'btn-secondary w-100 max-width-8-rem'"
      [text]="'accessibility.close' | translate"
      [type]="'rounded'">
    </app-button>
  </div>
</div>
</ng-template>

<ng-template #closeBrowser>
  <div class="w-100 d-flex justify-content-center align-items-center flex-column text-center max-height-90">
    <div class="pt-3 pe-3 d-flex w-100 justify-content-end">
      <app-button
        (clicked)="close()"
        [ariaLabel]="'accessibility.close' | translate"
        [class]="'button-color-gray'"
        [color]="'gray'"
        [svgIcon]="'close_x'"
        [type]="'circle'">
      </app-button>
    </div>
    <div class="info-header-title">{{ 'logout.successTitle' | translate }}</div>
    <div class="p-3 overflow-auto">
        {{ 'logout.closeBrowser' | translate }}
    </div>
    <div class="pb-3 max-width-8-rem ">
      <app-button
        (clicked)="close()"
        [ariaLabel]="'accessibility.close' | translate"
        [class]="'btn-secondary w-100 max-width-8-rem'"
        [text]="'accessibility.close' | translate"
        [type]="'rounded'">
      </app-button>
    </div>
  </div>
</ng-template>
